import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { getOptionGroup } from 'src/api/getOptionGroup/getOptionGroup';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { QueryKeys } from 'src/hooks/QueryKeys';
import { IOptionGroup } from 'src/types/menu.types';
import { formatOptionGroup } from './formatOptionGroup/formatOptionGroup';

export const useOptionGroup = (optionGroupId?: string, priceSchemeId?: string): UseQueryResult<IOptionGroup> => {
  const { showSnackbar } = useSnackbar();

  return useQuery<IOptionGroup>({
    queryKey: [QueryKeys.optionGroups, getBrandId(), optionGroupId, priceSchemeId],
    queryFn: async () => {
      try {
        const optionGroup = await getOptionGroup(optionGroupId, priceSchemeId);
        return formatOptionGroup(optionGroup);
      } catch (error) {
        showSnackbar({
          status: SnackbarStatus.ERROR,
          message: (error as Error)?.message || 'Internal Server Error',
        });
        throw error;
      }
    },
    enabled: !!(optionGroupId && priceSchemeId),
    refetchOnWindowFocus: false,
  });
};
